<template>
  <div class="activity-container">
    <div class="activity-wrap main-width">
      <v-title title="活动预告" url="/views/activity/yugao" />
      <div class="activity-content">
        <div class="yugao-item" v-for="(item, index) in yugaoList" :key="index">
          <Yugao :info="item"></Yugao>
        </div>
      </div>
    </div>
    <div class="activity-wrap main-width">
      <v-title title="前沿观点" url="/views/activity/qianyan" />
      <div class="activity-content">
        <div class="qianyan-item" v-for="(item, index) in qianyanList" :key="index">
          <Qianyan :info="item"></Qianyan>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VTitle from "./components/title/index";
import Yugao from "./components/activity/yudao";
import Qianyan from "./components/activity/qianyan";
export default {
  data() {
    return {

    }
  },
  props: {
    yugaoList: {
      type: Array,
      default: () => []
    },
    qianyanList: {
      type: Array,
      default: () => []
    },
  },
  components: {
    VTitle, Yugao,
    Qianyan
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.activity-container {
  .activity-content {
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    .yugao-item {
      width: calc((100% - 60px) / 3);
    }
    .qianyan-item {
      width: calc((100% - 90px) / 4);
    }
  }
}

@media screen and (max-width: 768px) {
  .activity-container {
    .activity-content {
      justify-content: center;
      padding: 14px 0;
      flex-direction: column;
      gap: 14px;
      .yugao-item {
        width: 100%;
      }
      .qianyan-item {
        width: 100%;
      }
    }
  }
}
</style>